import { createSlice } from '@reduxjs/toolkit';
// import { database } from 'faker/locale/en_AU';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  clients: null,
  cadences: null,
  createdClient: null,
  detailInfo: null,
  updateClient: null,
  scheduledPauses: null,
  clientEndpoints: null,
  createEndpoints: null,
  updateEndpoints: null,
  duplicateEndpoints: null,
  endpointMap: null,
  updateMap: null,
  clientTokens: null,
  createTokens: null,
  deleteTokens: null,
  updateTokens: null,
  clientIntegrationsEx: null,
  postBacks: null,
  createIntegrationsEx: null,
  deleteIntegrationsEx: null,
  updateIntegrationsEx: null,
  columns: null,
  data: null,
  leadSearchData: null,
  saveLeadData: null,
  fieldMappings:[],
  authenticationTypes:[],
  sendTypes:[],
  endPointTypes: [],
  lqclientproductlist:[],
  lqsaidlist:[],
  cadencenames:[],
  clientExceptions:[],
  createCadence: null,
  duplicateCadence: null,
  updateCadence: null,
  deleteCadences: null,
  createPhoneConf: null,
  updatePhoneConf: null,
  createSMSConf: null,
  updateSMSConf: null,
  createEmailConf: null,
  updateEmailConf: null,
  createTouchPoint: null,
  archiveCadences: null,
  createFolloup: null,
  createEndCadence: null,
  updateFolloup: null,
  deleteFolloup: null,
  deleteEndCadence: null,
  updateEndCadence: null,
  endMap : null,
  disposition: null,
  touchPoint: null,
  inbountTouch: null,
  leadData: null,
  options: null,
  bookings: [],
  endCadenceType: null
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    formatError(state, action) {
      state.error = false;
    },

    saveColumn(state, action) {
      state.isLoading = false;
      state.columns = action.payload;
    },

    saveData(state, action) {
        state.isLoading = false;
        state.data = action.payload;
    },

    saveLeadData(state, action) {
      state.isLoading = false;
      state.saveLeadData = action.payload;
    },

    getClient(state, action) {
      state.isLoading = false;
      state.clients = action.payload;
    },

    getCadence(state, action) {
      state.isLoading = false;
      state.cadences = action.payload;
    },

    getLeadData(state, action) {
      state.isLoading = false;
      state.leadSearchData = action.payload;
    },

    //GET BOOKING LIST
    getBookingList(state, action) {
      state.isLoading = false;
      state.bookings = action.payload;
    },

    // GET PROFILE
    getClientIntegration(state, action) {
      state.isLoading = false;
      state.clients = action.payload;
    },

    // GET PROFILE
    getExceptionsByClientID(state, action) {
      state.isLoading = false;
      state.clientExceptions = action.payload;
    },
    // GET PROFILE
    clearExceptionsByClientId(state, action) {
      state.isLoading = false;
      state.clientExceptions = action.payload;
    },

    // GET PROFILE
    getFieldMappings(state, action) {
      state.isLoading = false;
      state.fieldMappings = action.payload;
    },
    getLqClientProductList(state, action) {
      state.isLoading = false;
      state.lqclientproductlist = action.payload;
    },

    getSaidID(state, action) {
      state.isLoading = false;
      state.lqsaidlist = action.payload;
    },

    getCadenceNames(state, action) {
      state.isLoading = false;
      state.cadencenames = action.payload;
    },

    //CREACT CLIENTINTEGRATION ACCOUNT
    createClientIntegration(state, action) {
      state.isLoading = false;
      state.createdClient = action.payload;
    },

    // TODO - finalize
    createClient(state, action) {
      state.isLoading = false;
      state.createdClient = action.payload;
    },    

    createClientEndpoints(state, action) {
      state.isLoading = false;
      state.createEndpoints = action.payload;
    },

    createClientCadences(state, action) {
      state.isLoading = false;
      state.createCadence = action.payload;
    },

    createClientTouchPoint(state, action) {
      state.isLoading = false;
      state.createTouchPoint = action.payload;
    },

    createClientFollowUp(state, action) {
      state.isLoading = false;
      state.createFolloup = action.payload;
    },

    updateClientFollowUp(state, action) {
      state.isLoading = false;
      state.updateFolloup = action.payload;
    },

    createClientEndCadnece(state, action) {
      state.isLoading = false;
      state.createEndCadence = action.payload;
    },

    updateClientEndCadnece(state, action) {
      state.isLoading = false;
      state.updateEndCadence = action.payload;
    },

    deleteClientEndCadence(state, action) {
      state.isLoading = false;
      state.deleteEndCadence = action.payload;
    },
    deleteClientFollowUp(state, action) {
      state.isLoading = false;
      state.deleteFolloup = action.payload;
    },
    
    createClientEndCadence(state, action) {
      state.isLoading = false;
      state.createEndCadence = action.payload;
    },

    updateClientEndCadence(state, action) {
      state.isLoading = false;
      state.updateEndCadence = action.payload;
    },
    
    duplicateClientCadences(state, action) {
      state.isLoading = false;
      state.duplicateCadence = action.payload;
    },

    createdPhoneConfiguration(state, action) {
      state.isLoading = false;
      state.createPhoneConf = action.payload;
    },

    createdEmailConfiguration(state, action) {
      state.isLoading = false;
      state.createEmailConf = action.payload;
    },

    createdSMSConfiguration(state, action) {
      state.isLoading = false;
      state.createSMSConf = action.payload;
    },

    updatedPhoneConfiguration(state, action) {
      state.isLoading = false;
      state.updatePhoneConf = action.payload;
    },
    
    updatedSMSConfiguration(state, action) {
      state.isLoading = false;
      state.updateSMSConf = action.payload;
    },

    updatedEmailConfiguration(state, action) {
      state.isLoading = false;
      state.updateEmailConf = action.payload;
    },

    deleteClientCadences(state, action) {
      state.isLoading = false;
      state.deleteCadences = action.payload;
    },

    ArchiveClientCadences(state, action) {
      state.isLoading = false;
      state.archiveCadences = action.payload;
    },

    getScheduledPauses(state, action) {
      state.isLoading = false;
      state.scheduledPauses = action.payload;
    },

    updateScheduledPauses(state, action) {
      state.isLoading = false;
      state.scheduledPauses = action.payload;
    },    
    
    updateClientEndpoints(state, action) {
      state.isLoading = false;
      state.updateEndpoints = action.payload;
    },

    duplicateClientEndpoints(state, action) {
      state.isLoading = false;
      state.duplicateEndpoints = action.payload;
    },    

    updateClientCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },
    
    startCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    pauseCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    updateClientTokens(state, action) {
      state.isLoading = false;
      state.updateTokens = action.payload;
    },

    createClientTokens(state, action) {
      state.isLoading = false;
      state.createTokens = action.payload;
    },

    deleteClientTokens(state, action) {
      state.isLoading = false;
      state.deleteTokens = action.payload;
    },

    updateClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.updateIntegrationsEx = action.payload;
    },

    createClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.createIntegrationsEx = action.payload;
    },

    deleteClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.deleteIntegrationsEx = action.payload;
    },

    getDetailInfo(state, action) {
      state.isLoading = false;
      state.detailInfo = action.payload;
    },
    
    // TODO - Finalize
    updateClient(state, action) {
      state.isLoading = false;
      state.updateClient = action.payload;
    },

    updateCadence(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    updateClientIntegration(state, action) {
      state.isLoading = false;
      state.updateClient = action.payload;
    },

    getClientEndpoints (state, action) {
      state.isLoading = false;
      state.clientEndpoints = action.payload;
    },

    getClientTokens (state, action) {
      state.isLoading = false;
      state.clientTokens = action.payload;
    },

    getClientIntegrationsEx (state, action) {
      state.isLoading = false;
      state.clientIntegrationsEx = action.payload;
    },

    getPostBacks (state, action) {
      state.isLoading = false;
      state.postBacks = action.payload;
    },

    getEndpointMap (state, action) {
      state.isLoading = false;
      state.endpointMap = action.payload;
    },

    getAuthenticationType (state, action) {
      state.isLoading = false;
      state.authenticationTypes = action.payload;
    },

    getSendType (state, action) {
      state.isLoading = false;
      state.sendTypes = action.payload;
    },

    getEndpointType (state, action) {
      state.isLoading = false;
      state.endPointTypes = action.payload;
    },

    updateEndpointMap (state, action) {
      state.isLoading = false;
      state.updateMap = action.payload;
    },
    getEndPointMapping (state, action){
      state.isLoading = false;
      state.endMap = action.payload;
    },
    getFinalDisposition (state, action) {
      state.isLoading = false;
      state.disposition = action.payload;
    },
    getTouchPointOutcome (state, action) {
      state.isLoading = false;
      state.touchPoint = action.payload;
    },
    getInboundTouchpoint (state, action) {
      state.isLoading = false;
      state.inbountTouch = action.payload;
    },
    getIncludeLeadData (state, action) {
      state.isLoading = false;
      state.leadData = action.payload;
    },
    getSubAccount (state, action){
      state.isLoading = false;
      state.subAccountData = action.payload;
    },
    getOptions (state, action){
      state.isLoading = false;
      state.options = action.payload;
    },
    getEndCadenceType (state, action){
      state.isLoading = false;
      state.endCadenceType = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow } = slice.actions;

export function saveCSVData(columns, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.saveColumn(columns));
    dispatch(slice.actions.saveData(data));
  };
}

export function saveLeadData(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/savelead', {data: data});
      dispatch(slice.actions.saveLeadData(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function saveLeadDataV1(id,data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      // const response = await axios.post('/api/v1/post/'+id, {data: data});
      const response = await axios.post('/api/v1/bulkleadpost/'+id, {data: data});
      dispatch(slice.actions.endLoading());
      return response.data
    } catch (error) {
      dispatch(slice.actions.endLoading());
      return []
    }
  };
}
export function formatSaveLeadData() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.saveLeadData(null));
  };
}

// ----------------------------------------------------------------------

export function getEndpointMap(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/getmapping', {id: id});
      dispatch(slice.actions.getEndpointMap(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function endpointFieldmappings(id) {
  return async (dispatch) => {
    //dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/mappings/endpoint/fieldmappings/'+id);
      return response
    } catch (error) {
      throw error
    }
  };
}


// ----------------------------------------------------------------------

export function getAuthenticationType() {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/getAuthenticationType');
    //   let tempData = response.data.filter((li, i) => li.id !== 3 && li.id !== 4)
      dispatch(slice.actions.getAuthenticationType(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getSendType() {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/getSendType');
      dispatch(slice.actions.getSendType(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEndpointType() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/getEndpointType');
      // dispatch(slice.actions.getEndpointType(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function updateEndpointMap(data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/saveFieldmappings', data);
      // dispatch(slice.actions.updateEndpointMap(response.data));
      return response.data;
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      return 0;
    }
  };
}

export function deleteEndpointVersion(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/deleteEndpointVersion', data);
      // dispatch(slice.actions.updateEndpointMap(response.data));
      return response.data;
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      return 0;
    }
  };
}

export function formatEndpointMap() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateEndpointMap(null));
  };
}

// ----------------------------------------------------------------------


// TODO - finalize

export function getAllEndpoints(data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadthrottle/getAllEndpoints', data);
      dispatch(slice.actions.getLeadData(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFieldMappings(clientId=null) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/mappings/fieldmappings/'+clientId);
      dispatch(slice.actions.getFieldMappings(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function publishVersion({id, name, description}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/publish/version',{id,name, description});
      dispatch(slice.actions.endLoading());
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return{
        state:'failed'
      }
    }
  };
}

export function routingVersionPublish(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/publishRouterVersion', {id: id});
      dispatch(slice.actions.endLoading());
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return{
        state:'failed'
      }
    }
  };
}


export function setAsLatestVersion(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/setAsLatestVersion',{id:id});
      dispatch(slice.actions.endLoading());
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return{
        state:'failed'
      }
    }
  };
}

export function formatClients(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClient(null));
  };
}

// ----------------------------------------------------------------------
export function formatUpdateClientIntegrations(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientIntegration(null));
  };
}

// TODO - finalize
export function formatUpdateClients(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClient(null));
  };
}

export function formatUpdateCadences(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateCadence(null));
  };
}

// ----------------------------------------------------------------------

export function createEndpoints(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/createndpoints', data);
      dispatch(slice.actions.createClientEndpoints(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createVersion(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/createversion', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function formatClientEndpoints() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClientEndpoints(null));
  };
}

export function formatClientTokens() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClientTokens(null));
  };
}

export function formatDeleteClientTokens() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.deleteClientTokens(null));
  };
}

export function formatClientIntegrationsEx() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClientIntegrationsEx(null));
  };
}

export function formatDeleteClientIntegrationsEx() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.deleteClientIntegrationsEx(null));
  };
}

// ----------------------------------------------------------------------
export function updateClientEndpoints(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/updatendpoints', data);
      dispatch(slice.actions.updateClientEndpoints(response.data));
      return response;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function duplicateClientEndpoints(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/duplicatendpoints', data); /* TODO: Change to */
      dispatch(slice.actions.duplicateClientEndpoints(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



export function formatUpdateEndpoints() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientEndpoints(null));
  };
}

export function formatDuplicateEndpoints() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.duplicateClientEndpoints(null));
  };
}

export function formatUpdateTokens() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientTokens(null));
  };
}

export function formatUpdateIntegrationsEx() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientIntegrationsEx(null));
  };
}


// ----------------------------------------------------------------------
export function getClientEndpoints(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/iapi/getendpoints?id=${id}&is_version=0`);
      dispatch(slice.actions.getClientEndpoints(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------
export function getEndpointsList(id, is_version=0) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/getEndpointsList', {id: id, is_version});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEndPointMapping(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      
      
      const response = await axios.get(`/iapi/getendpoints?id=${id}&is_version=0`);
      dispatch(slice.actions.getEndPointMapping(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function getEndpointById(id, is_version=0) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/client/endpoint/getEndpointById', {id: id, is_version});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFieldsListById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/api/dataExport/getFieldsById', { id });
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}